import { ITmErrorProps } from './tm-error';

export const tmErrorMockData404: ITmErrorProps = {
  heading: '404 Error',
  heading_variant: 'h3',
  topSpacing: 'lg',
  bottomSpacing: 'xs',
  body: `<h3>(Page Not Found)</h3><br><br>Oops! The page you're looking for seems to have wandered off the construction site. It might be under renovation, or perhaps it's moved to a new address. Let's get you back on track:<br><br>Head back to the <a href="/">Homepage</a>.<br>Need help finding something specific? We're just a <a href="/contact-us">call or click away</a>.<br><br>We apologize for the dust! We're always building something new, so stick around.`,
};

export const tmErrorMockData500: ITmErrorProps = {
  heading: '500 Error',
  heading_variant: 'h3',
  topSpacing: 'lg',
  bottomSpacing: 'xs',
  body: `<h3>(Something went wrong)</h3><br><br>Oops! Let's get you back on track:<br><br>Head back to the <a href="/">Homepage</a>.<br>Need help finding something specific? We're just a <a href="/contact-us">call or click away</a>.<br><br>We apologize for the dust! We're always building something new, so stick around.`,
};
